import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { Typography, useMediaQuery } from '@material-ui/core'
import doctor_img from '../../../../assests/images/PatientApoointment/doctorImg.png'

const AppointmentLoadingPage = (props) => {
    const isTablet = useMediaQuery((theme) =>
        theme.breakpoints.down('lg'),
    );
    return (
        <div className="left-side-portion" >
           
            <div className="middle_portion_loader">
                <div>
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
                        <CircularProgress />
                    </Box>
                    <Typography
                        className="text_holder"
                        style={{
                            color: '#303E4E',
                            fontFamily: 'Inter',
                            fontSize: '20px',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            lineHeight: '24px',
                        }}>
                        {props.steps == 1
                            ? 'Hang tight, confirming your creation.'
                            : 'Hang tight, confirming your selection is available.'}
                    </Typography>
                </div>
            </div>
        </div>
    )
}

export default AppointmentLoadingPage
